
export const PREVIEW_NEWSBRIEF = 'PREVIEW_NEWSBRIEF'

export const URL_HOME = '/newsbrief'